import { ACT_NVT_CHANGE } from "./ActionTypes";
import NoveltyService from "../provider/novelty/NoveltyService"; 
import MediaService from "../provider/media/MediaService"; 

import {loading} from "./AppActions"

/*** ACTIONS NEWS ******/
export function actionGetNews(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      NoveltyService.getNews(getStore().app.app).then((response) => {
        // console.log("NEWS RESPONSE", response)
        dispatch({
            type: ACT_NVT_CHANGE,
            props: {noveltyList:response}
        })
        succesCallback&&succesCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSaveNovelty(novelty, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      novelty.nvtDate=new Date(novelty.nvtDate).getTime()
        if(!novelty.nvtImg || typeof novelty.nvtImg == 'string'){//Si tiene una url y no un archivo seleccionado con el componente
          if(!novelty.nvtImg&&novelty.nvtPathImg){
            MediaService.deleteFile(novelty.nvtPathImg)
            delete novelty.nvtNameImg
            delete novelty.nvtPathImg
          }
          NoveltyService.saveNovelty(getStore().app.app, novelty).then((response) => {
            successCallback()
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }else{ //Si tiene un archivo seleccionado por el componente
          
          MediaService.uploadFile(novelty.nvtImg, 'news', 'image').then(res => {
            if(novelty.nvtPathImg&&novelty.nvtPathImg!=res.path){
              MediaService.deleteFile(novelty.nvtPathImg)
            }
            novelty.nvtImg=res.downloadURL
            novelty.nvtNameImg=res.filename
            novelty.nvtPathImg=res.path
            NoveltyService.saveNovelty(getStore().app.app, novelty).then((response) => {
              successCallback()
            }).catch(errorCallback)
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }
      
  };
}

export function actionDeleteNovelty(novelty, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      NoveltyService.deleteNovelty(getStore().app.app, novelty.id).then((response) => {
        if(novelty.nvtPathImg){
          MediaService.deleteFile(novelty.nvtPathImg)
        }
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

/****** FIN ACTION NEWS +**********/


// WEBPACK FOOTER //
// ./src/actions/NoveltyActions.js